import Cookies from "js-cookie";
import { DAPI_COOKIE_NAME } from "../constants";

export default function getDapiRandomId(): string | undefined {
  return Cookies.get(DAPI_COOKIE_NAME);
}
